"use client";
var re = Object.defineProperty;
var se = (e, t, o) => t in e ? re(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var H = (e, t, o) => se(e, typeof t != "symbol" ? t + "" : t, o);
import { j as ie } from "./jsx-runtime-B6kdoens.js";
import { useEffect as f, useState as h } from "react";
import { useInView as ce } from "react-intersection-observer";
import { useLevo as S } from "./providers/index.js";
import { usePageLifecycle as ae, LifecycleState as x } from "use-page-lifecycle";
import { LocalStorageLock as ue } from "@levo-so/core";
const bt = ({ id: e, properties: t = {} }) => {
  const { audience: o } = S(), { ref: n, inView: s } = ce({
    triggerOnce: !0
  });
  return f(() => {
    o != null && o.instance && s && (o == null || o.track("block.view", {
      ...t,
      resource: "block",
      identifier: e
    }));
  }, [s]), /* @__PURE__ */ ie.jsx("div", { ref: n, style: { height: "0px" } });
}, vt = ({ event: e, properties: t }) => {
  const { audience: o } = S();
  return f(() => {
    o != null && o.instance && (o == null || o.track(e, t));
  }, [o == null ? void 0 : o.instance, e, t]), null;
};
function P(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var de = typeof global == "object" && global && global.Object === Object && global, le = typeof self == "object" && self && self.Object === Object && self, J = de || le || Function("return this")(), M = function() {
  return J.Date.now();
}, fe = /\s/;
function me(e) {
  for (var t = e.length; t-- && fe.test(e.charAt(t)); )
    ;
  return t;
}
var pe = /^\s+/;
function ge(e) {
  return e && e.slice(0, me(e) + 1).replace(pe, "");
}
var N = J.Symbol, z = Object.prototype, he = z.hasOwnProperty, we = z.toString, k = N ? N.toStringTag : void 0;
function be(e) {
  var t = he.call(e, k), o = e[k];
  try {
    e[k] = void 0;
    var n = !0;
  } catch {
  }
  var s = we.call(e);
  return n && (t ? e[k] = o : delete e[k]), s;
}
var ve = Object.prototype, ye = ve.toString;
function Se(e) {
  return ye.call(e);
}
var Te = "[object Null]", Ee = "[object Undefined]", Y = N ? N.toStringTag : void 0;
function Le(e) {
  return e == null ? e === void 0 ? Ee : Te : Y && Y in Object(e) ? be(e) : Se(e);
}
function ke(e) {
  return e != null && typeof e == "object";
}
var Ce = "[object Symbol]";
function xe(e) {
  return typeof e == "symbol" || ke(e) && Le(e) == Ce;
}
var W = NaN, _e = /^[-+]0x[0-9a-f]+$/i, Ne = /^0b[01]+$/i, Oe = /^0o[0-7]+$/i, Ie = parseInt;
function K(e) {
  if (typeof e == "number")
    return e;
  if (xe(e))
    return W;
  if (P(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = P(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = ge(e);
  var o = Ne.test(e);
  return o || Oe.test(e) ? Ie(e.slice(2), o ? 2 : 8) : _e.test(e) ? W : +e;
}
var Re = "Expected a function", Ae = Math.max, je = Math.min;
function Me(e, t, o) {
  var n, s, i, a, u, r, c = 0, d = !1, l = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(Re);
  t = K(t) || 0, P(o) && (d = !!o.leading, l = "maxWait" in o, i = l ? Ae(K(o.maxWait) || 0, t) : i, p = "trailing" in o ? !!o.trailing : p);
  function g(m) {
    var w = n, L = s;
    return n = s = void 0, c = m, a = e.apply(L, w), a;
  }
  function v(m) {
    return c = m, u = setTimeout(y, t), d ? g(m) : a;
  }
  function T(m) {
    var w = m - r, L = m - c, B = t - w;
    return l ? je(B, i - L) : B;
  }
  function E(m) {
    var w = m - r, L = m - c;
    return r === void 0 || w >= t || w < 0 || l && L >= i;
  }
  function y() {
    var m = M();
    if (E(m))
      return R(m);
    u = setTimeout(y, T(m));
  }
  function R(m) {
    return u = void 0, p && n ? g(m) : (n = s = void 0, a);
  }
  function A() {
    u !== void 0 && clearTimeout(u), c = 0, n = r = s = u = void 0;
  }
  function oe() {
    return u === void 0 ? a : R(M());
  }
  function j() {
    var m = M(), w = E(m);
    if (n = arguments, s = this, r = m, w) {
      if (u === void 0)
        return v(r);
      if (l)
        return clearTimeout(u), u = setTimeout(y, t), g(r);
    }
    return u === void 0 && (u = setTimeout(y, t)), a;
  }
  return j.cancel = A, j.flush = oe, j;
}
const De = () => {
  const [e, t] = h(0), [o, n] = h(0), [s, i] = h(0), [a, u] = h(Date.now()), [r, c] = h("read"), d = Me(() => {
    const l = window.scrollY, p = document.documentElement.scrollHeight, g = window.innerHeight, v = Math.round(
      l / (p - g) * 100
    ), T = Math.floor(v / 5) * 5;
    if (T <= o)
      return;
    const E = Date.now(), y = (E - a) / 1e3, A = Math.abs(l - s) / y;
    c(A > 300 ? "scan" : "read"), i(l), u(E), n(T), t(T);
  }, 250);
  return f(() => (window.addEventListener("scroll", d), () => window.removeEventListener("scroll", d)), []), { depth: e, speedCategory: r };
}, C = "lv_insights_ot", $e = () => {
  const [e, t] = h(0);
  return f(() => {
    const o = Number(localStorage.getItem(C)) || 0;
    t(o), localStorage.setItem(C, (o + 1).toString());
    const n = (i) => {
      i.key === C && t(Number(i.newValue) || 0);
    };
    window.addEventListener("storage", n);
    const s = () => {
      const i = Number(localStorage.getItem(C)) || 0;
      i > 0 && localStorage.setItem(C, (i - 1).toString());
    };
    return window.addEventListener("beforeunload", s), () => {
      window.removeEventListener("storage", n), window.removeEventListener("beforeunload", s);
    };
  }, []), e;
}, G = "lv_insights_ct", D = "lv_insights_at", Pe = () => {
  const [e, t] = h(null);
  return f(() => {
    let o = sessionStorage.getItem(G);
    const n = JSON.parse(
      localStorage.getItem(D) || "[]"
    );
    o && n.includes(o) && (o = null), o || (o = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, sessionStorage.setItem(G, o)), n.includes(o) || (n.push(o), localStorage.setItem(
      D,
      JSON.stringify(n)
    )), t(o);
    const s = () => {
      const i = n.filter(
        (a) => a !== o
      );
      localStorage.setItem(
        D,
        JSON.stringify(i)
      );
    };
    return window.addEventListener("beforeunload", s), () => {
      window.removeEventListener("beforeunload", s);
    };
  }, []), e;
}, O = (e) => Object.prototype.toString.call(e) == "[object String]", Fe = (e, t) => e.indexOf(t) !== -1, I = (e) => e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), X = (e) => e === void 0, Ue = (e) => e === null, q = (e) => X(e) || Ue(e), Z = (e) => !!e && (e == null ? void 0 : e.nodeType) === 3;
function Be(e) {
  return !!e && (e == null ? void 0 : e.nodeType) === 1;
}
function He(e, t) {
  return !!e && !!(e != null && e.tagName) && (e == null ? void 0 : e.tagName.toLowerCase()) === t.toLowerCase();
}
function Ye(e) {
  return e ? I(e).split(/\s+/) : [];
}
function We(e) {
  let t = "";
  switch (typeof (e == null ? void 0 : e.className)) {
    case "string":
      t = e == null ? void 0 : e.className;
      break;
    case "object":
      t = (e != null && e.className && "baseVal" in (e == null ? void 0 : e.className) ? (e == null ? void 0 : e.className).baseVal : null) || (e == null ? void 0 : e.getAttribute("class")) || "";
      break;
    default:
      t = "";
  }
  return Ye(t);
}
const b = (e, t = 255) => q(e) ? "" : I(e).split(/(\s+)/).filter((o) => U(o)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, t), F = (e) => {
  let t = "";
  if (Ve(e) && // !isSensitiveElement(el) &&
  (e != null && e.childNodes) && (e != null && e.childNodes.length))
    for (const o of e == null ? void 0 : e.childNodes)
      Z(o) && o.textContent && (t += b(o.textContent) ?? "");
  return I(t);
}, Ke = (e) => {
  var t, o;
  return X(e.target) ? (e == null ? void 0 : e.srcElement) || null : (t = e == null ? void 0 : e.target) != null && t.shadowRoot ? ((o = e == null ? void 0 : e.composedPath()) == null ? void 0 : o[0]) || null : (e == null ? void 0 : e.target) || null;
}, Ge = (e, t) => {
  if (!window || !e || He(e, "html") || !Be(e))
    return !1;
  const o = window.getComputedStyle(e);
  if (o && o.getPropertyValue("cursor") === "pointer" && t.type === "click")
    return !0;
  switch (e == null ? void 0 : e.tagName.toLowerCase()) {
    case "html":
      return !1;
    case "form":
      return t.type === "submit";
    case "input":
    case "select":
    case "textarea":
      return ["change", "click"].includes(t.type);
    default:
      return t.type === "click";
  }
};
function Ve(e) {
  if (Fe(We(e), "ph-include"))
    return !0;
  const t = e.type || "";
  if (O(t))
    switch (t.toLowerCase()) {
      case "hidden":
        return !1;
      case "password":
        return !1;
    }
  const o = e.name || (e == null ? void 0 : e.id) || "";
  return !(O(o) && /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(o.replace(/[^a-zA-Z0-9]/g, "")));
}
const Q = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", Je = new RegExp(`^(?:${Q})$`), ze = new RegExp(Q), ee = "\\d{3}-?\\d{2}-?\\d{4}", Xe = new RegExp(`^(${ee})$`), qe = new RegExp(`(${ee})`), U = (e, t = !0) => !(q(e) || O(e) && (e = I(e), (t ? Je : ze).test((e || "").replace(/[- ]/g, "")) || (t ? Xe : qe).test(e))), Ze = (e) => O(e) ? e.substring(0, 10) === "_ngcontent" || e.substring(0, 7) === "_nghost" : !1, Qe = (e) => {
  let t = F(e);
  return t = `${t} ${te(e)}`.trim(), U(t) ? t : "";
};
function te(e) {
  var o;
  let t = "";
  if (e != null && e.childNodes.length) {
    for (const n of e.childNodes)
      if (n && ((o = n.tagName) == null ? void 0 : o.toLowerCase()) === "span")
        try {
          const s = F(n);
          t = `${t} ${s}`.trim(), n != null && n.childNodes.length && (t = `${t} ${te(n)}`.trim());
        } catch {
        }
  }
  return t;
}
const et = ["input", "textarea", "select"], ne = (e) => {
  var s, i, a, u;
  const t = (s = e == null ? void 0 : e.tagName) == null ? void 0 : s.toLowerCase(), o = {
    element: t
  };
  (t == null ? void 0 : t.toLowerCase()) === "a" || (t == null ? void 0 : t.toLowerCase()) === "button" ? o.text = Qe(e) : o.text = F(e);
  const n = Array.from(e.attributes).reduce(
    (r, c) => {
      if (U(c.value) && !Ze(c.name)) {
        if (c.name === "class")
          return r;
        r[c.name] = typeof (c == null ? void 0 : c.value) == "string" ? b(c.value) : c.value;
      }
      return r;
    },
    {}
  );
  if (o.attributes = n, et.includes(t) || (e == null ? void 0 : e.getAttribute("contenteditable")) === "true") {
    let r;
    e.matches('input[type="checkbox"], input[type="radio"]') ? r = e.checked : e.matches("input, select, textarea") && !e.matches('input[type="password"]') && (r = e.value), r !== void 0 && (o.value = typeof r == "string" || r === null ? b(r, 1024) : r);
    let c = "";
    o != null && o.attributes.id && (c = b(
      ((a = (i = document.querySelector(`label[for="${o == null ? void 0 : o.attributes.id}"]`)) == null ? void 0 : i.textContent) == null ? void 0 : a.trim()) || ""
    ));
    const d = e.closest("label");
    c || (c = b(((u = d == null ? void 0 : d.textContent) == null ? void 0 : u.trim()) || "")), c && (o.label = c);
  }
  return o;
}, tt = (e, t) => {
  var s;
  let o = Ke(e);
  Z(o) && (o = o.parentNode || null);
  const n = ["copy", "cut"].includes(t);
  if (o && (n || Ge(o, e))) {
    const i = ne(o);
    if (n) {
      const a = b((s = window == null ? void 0 : window.getSelection()) == null ? void 0 : s.toString()), u = (e == null ? void 0 : e.type) || "clipboard";
      i.copy_text = a ?? "", i.copy_type = u ?? "";
    }
    return i;
  }
  return null;
}, nt = 30, ot = 1e3, rt = 3;
class st {
  constructor() {
    H(this, "clicks");
    this.clicks = [];
  }
  isRageClick(t, o, n) {
    const s = this.clicks[this.clicks.length - 1];
    if (s && Math.abs(t - s.x) + Math.abs(o - s.y) < nt && n - s.timestamp < ot) {
      if (this.clicks.push({ x: t, y: o, timestamp: n }), this.clicks.length === rt)
        return !0;
    } else
      this.clicks = [{ x: t, y: o, timestamp: n }];
    return !1;
  }
}
const $ = new st(), it = () => {
  const { audience: e } = S();
  f(() => {
    let t = null;
    const o = (i) => {
      if (t) {
        clearTimeout(t), t = null;
        return;
      }
      t = setTimeout(() => {
        s(i, !1), t = null;
      }, 250);
    }, n = (i) => {
      t && (clearTimeout(t), t = null), s(i, !0);
    }, s = (i, a = !1) => {
      var u;
      try {
        let r = {
          hostname: window.location.hostname,
          pathname: window.location.pathname,
          page_title: document.title,
          url: window.location.href,
          created_at: (/* @__PURE__ */ new Date()).toISOString(),
          event_type: a ? "dblclick" : "click",
          button_type: i.button
        };
        if (i.target instanceof HTMLElement) {
          const c = i.target;
          r.rage_click = $ == null ? void 0 : $.isRageClick(
            i.clientX,
            i.clientY,
            (/* @__PURE__ */ new Date()).getTime()
          ), r = {
            ...r,
            ...ne(c)
          };
          let d = c == null ? void 0 : c.getAttribute("href");
          if (!d) {
            let l = c.parentNode, p = 0;
            for (; l && p < 8; ) {
              const g = (u = l == null ? void 0 : l.parentElement) == null ? void 0 : u.getAttribute("href");
              if (g) {
                d = g;
                break;
              }
              l = l.parentNode, p++;
            }
          }
          e == null || e.track("page.click", {
            ...r,
            href: d || void 0
          });
        }
      } catch {
      }
    };
    return document.addEventListener("click", o), document.addEventListener("dblclick", n), () => {
      document.removeEventListener("click", o), document.removeEventListener("dblclick", n);
    };
  }, [e]);
}, _ = (e) => Number(e.toFixed(0)), ct = (e) => {
  const { audience: t } = S(), [o] = h({
    value: _(performance.now()),
    timestamp: _(Date.now())
  }), [n, s] = h({
    value: null,
    timestamp: null
  }), [i, a] = h({
    value: null,
    timestamp: null
  });
  return f(() => {
    let u = !0;
    const r = (l, p) => {
      u && l({ value: _(p), timestamp: _(Date.now()) });
    }, c = new PerformanceObserver((l) => {
      for (const p of l.getEntries())
        p.name === "first-contentful-paint" && r(s, p.startTime);
    });
    c.observe({ type: "paint", buffered: !0 });
    const d = () => r(a, performance.now());
    return document.readyState === "complete" ? r(a, performance.now()) : window.addEventListener("load", d), () => {
      u = !1, c.disconnect(), window.removeEventListener("load", d);
    };
  }, []), f(() => {
    o && t && (t == null || t.track("page.metrics", {
      script_load: o.value,
      script_load_at: o.timestamp,
      version: 2
    }));
  }, [o, t]), f(() => {
    n.value !== null && t && (t == null || t.track("page.metrics", {
      first_contentful_paint: n.value,
      first_contentful_paint_at: n.timestamp,
      version: 2
    }));
  }, [n, t]), f(() => {
    i.value !== null && t && (t == null || t.track("page.metrics", {
      window_onload: i.value,
      window_onload_at: i.timestamp,
      version: 2
    }));
  }, [i, t]), { script: o, fcp: n, window_onload: i };
}, at = () => {
  const { audience: e } = S();
  f(() => {
    let t;
    const o = () => {
      clearTimeout(t), t = setTimeout(() => {
        const n = window.getSelection();
        if (n && (n == null ? void 0 : n.rangeCount) > 0) {
          const s = n == null ? void 0 : n.toString();
          s && (e == null || e.track("page.selection", {
            text: b(s)
          }));
        }
      }, 1e3);
    };
    return document.addEventListener("selectionchange", o), () => {
      clearTimeout(t), document.removeEventListener("selectionchange", o);
    };
  }, []);
}, V = "lv_insights_st", ut = 15 * 60 * 1e3, dt = (e = "https://cachefly.cachefly.net/1mb.test") => {
  const [t, o] = h(null);
  return f(() => {
    const n = localStorage.getItem(V);
    if (n) {
      const { speed: u, timestamp: r } = JSON.parse(n);
      if (Date.now() - r < ut) {
        o(u);
        return;
      }
    }
    let s = null;
    const i = async () => {
      const u = new ue("download_speed");
      if (u.acquireLock())
        try {
          const c = performance.now();
          await fetch(e, { cache: "no-store" });
          const l = (performance.now() - c) / 1e3, p = Math.round(8 / l);
          o(p), localStorage.setItem(
            V,
            JSON.stringify({ speed: p, timestamp: Date.now() })
          );
        } catch {
        } finally {
          u.releaseLock();
        }
    }, a = () => {
      document.removeEventListener("mousemove", a), document.removeEventListener("keydown", a), document.removeEventListener("scroll", a), s = setTimeout(i, 5e3);
    };
    return document.addEventListener("mousemove", a, { once: !0 }), document.addEventListener("keydown", a, { once: !0 }), document.addEventListener("scroll", a, { once: !0 }), () => {
      s && clearTimeout(s), document.removeEventListener("mousemove", a), document.removeEventListener("keydown", a), document.removeEventListener("scroll", a);
    };
  }, [e]), t;
}, yt = ({ id: e, properties: t = {} }) => {
  var u;
  const o = typeof window < "u" ? window.location.href : "", n = S();
  f(() => {
    n && typeof window < "u" && (window.levo_client = n);
  }, [n]), f(() => {
    n != null && n.audience && typeof window < "u" && (window.levo_audience = n == null ? void 0 : n.audience);
  }, []), $e(), Pe(), it();
  const s = dt();
  f(() => {
    var r;
    (r = n == null ? void 0 : n.audience) != null && r.instance && s && (n == null || n.audience.track("user.speedtest", {
      speed: s,
      unit: "Mbps"
    }));
  }, [s]);
  const i = De();
  f(() => {
    var r;
    (r = n == null ? void 0 : n.audience) != null && r.instance && (n == null || n.audience.track("page.scroll", {
      resource: "page",
      identifier: e,
      percent: i.depth,
      speed_category: i.speedCategory
    }));
  }, [
    (u = n == null ? void 0 : n.audience) == null ? void 0 : u.instance,
    i.depth,
    i.speedCategory,
    e
  ]), ct(), at(), f(() => {
    const r = () => {
      var c;
      (c = n == null ? void 0 : n.audience) == null || c.bounce({
        resource: "page",
        identifier: e
      });
    };
    return window && window.addEventListener("beforeunload", r), () => {
      window && window.removeEventListener("beforeunload", r);
    };
  }, [n == null ? void 0 : n.audience, e]);
  const [a] = ae();
  return f(() => {
    var r;
    (a === x.TERMINATED || a === x.HIDDEN || a === x.UNKNOWN || a === x.FROZEN) && ((r = n == null ? void 0 : n.audience) == null || r.bounce({
      resource: "page",
      identifier: e,
      state: a
    }));
  }, [a, n == null ? void 0 : n.audience, e]), f(() => {
    (() => {
      var c, d;
      n != null && n.insightsUrl && n.workspace && o && ((c = n == null ? void 0 : n.audience) != null && c.instance ? n == null || n.audience.instance.page({
        resource: "page",
        identifier: e
      }) : (d = n == null ? void 0 : n.audience) == null || d.initiate({
        ...t,
        id: e,
        created_at: (/* @__PURE__ */ new Date()).toISOString()
      }));
    })();
  }, [n == null ? void 0 : n.insightsUrl, n == null ? void 0 : n.workspace, o]), f(() => {
    const r = {
      change: "form.change",
      submit: "form.submit",
      copy: "page.copy",
      cut: "page.copy"
    }, c = (l) => (p) => {
      var v;
      const g = tt(p, l);
      g && ((v = n == null ? void 0 : n.audience) == null || v.track(r[l], g));
    }, d = {
      change: c("change"),
      copy: c("copy"),
      cut: c("cut"),
      submit: c("submit")
    };
    return document.addEventListener("change", d.change), document.addEventListener("copy", d.copy), document.addEventListener("cut", d.cut), document.addEventListener("submit", d.submit), () => {
      document.removeEventListener("change", d.change), document.removeEventListener("copy", d.copy), document.removeEventListener("cut", d.cut), document.removeEventListener("submit", d.submit);
    };
  }, []), (!(n != null && n.insightsUrl) || !n.workspace || !n.workspace.startsWith("W")) && console.error(
    "[@levo-so/react] The utility could not be initialized, due to missing workspace, or endpoint for insights."
  ), null;
};
export {
  bt as L,
  vt as a,
  yt as b
};
